
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("i9AWo", function(module, exports) {
module.exports = JSON.parse("{}");

});


//# sourceMappingURL=en-US.c679593a.js.map
